import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Security360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/security/overview").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Security360" title="Physical Security & Asset Protection" description="Access control, perimeter monitoring, CCTV, patrols, product dispatch security, insider risk indicators and incident case management." />
            <KpiGrid kpis={data?.kpis || []} accent="red" cols={4} />
            <Panel title="Security Event Log" accent="red">
                <DataTable
                    columns={[
                        { key: "ref", label: "Ref" },
                        { key: "ts", label: "When", render: (r) => r.ts.slice(0, 16).replace("T", " ") },
                        { key: "type", label: "Type" },
                        { key: "zone", label: "Zone" },
                        { key: "severity", label: "Severity", render: (r) => <StatusChip status={statusToChip(r.severity)}>{r.severity}</StatusChip> },
                        { key: "handled_by", label: "Handled by" },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                    ]}
                    rows={(data?.events || []).slice(0, 30)}
                    testid="security-events"
                />
            </Panel>
        </div>
    );
}
